<template>
  <div>
    <h1>NMB48劇場 公演情報</h1>
    <div class="top">
    <p>NMB48の劇場公演予定・チケット申込期間をまとめた非公式サイトです。</p>
    <p class="ad-disclosure">当サイトには広告およびアフィリエイトリンクが含まれる場合があります。</p>
    <p>最新の情報やイレギュラーな申込期間が反映されていない可能性があります。正式な情報は<a href="https://ameblo.jp/nmb48/theme-10033701523.html" target="_blank">公式ブログ</a>、
      及び<a href="https://r.ticket.fany.lol/NMB48" target="_blank">FANYチケットサイト</a>をご確認ください。</p>
    <p class="mobile-only last-updated">最終更新日：{{ lastUpdated }}</p>
    </div>

    <div class="content-area">

      <div class="affiliate-info-area affiliate-info-area-top" aria-label="遠征向け関連情報">
        <a
          class="travel-affiliate-card affiliate-card"
          :href="rakutenTravelNambaHotelsUrl"
          target="_blank"
          rel="nofollow sponsored noopener"
          @click="trackRakutenTravelClick"
        >
          <span class="travel-affiliate-icon" aria-hidden="true">宿</span>
          <span class="travel-affiliate-copy">
            <span class="affiliate-card-label">大阪へ遠征する方へ <span class="affiliate-card-pr">PR</span></span>
            <strong>なんば周辺のホテルを探す</strong>
            <span class="affiliate-card-cta">楽天トラベルで宿泊先を見る →</span>
          </span>
        </a>
      </div>

      <div class="filter-container">
        <select id="filter-select" v-model="selectedFilter">
        <option value="all">全ての公演</option>
        <option value="available">申込可能な公演</option>
        <option value="available-lottery">申込可能な公演(先着除く)</option>
        </select>

        <p class="last-updated hide-on-mobile">最終更新日：{{ lastUpdated }}</p>
      </div>
    
    <table class="performance-table">
      <thead>
      <tr>
      <th>公演日</th>
      <th>公演名</th>
      <th class="hide-on-mobile">開演</th>
      <th class="hide-on-mobile">rooms先行</th>
      <th>モバイル<br/>先行</th>
      <th>一般(抽選)・<br/>女性エリア</th>
      <th>一般(先着)</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="performance in filterPerformances" :key="performance.id"
      v-bind:class="{
      'red': performance.name.includes('めっちゃ楽舞友'),
      'blue': performance.name.includes('恋のDestination'),
      'yellow': performance.name.includes('ここにだって天使はいる'),
      'green': performance.name.includes('無限大ノック'),
      'deepblue': performance.name.includes('天使のユートピア'),
       }">
        <td>{{ formatDay(performance.startDate) }}<span class="mobile-only"><br><br>{{ formatTime(performance.startDate) }}</span></td>
        <td>{{ performance.name }}<br/><span>{{ performance.subname }}</span><br/>
          <button v-show="hasCast(performance.cast)" button @click="showModal(performance)">出演</button>
          <p class="mobile-only rooms-info" 
          v-bind:class="{'rooms-info-now': isBetweenNow(performance.ticketSales.roomsSale?.start, performance.ticketSales.roomsSale?.end),
            'rooms-info-end': isEnd(performance.ticketSales.roomsSale?.end)
          }"
          v-if="performance.ticketSales.roomsSale?.start"><br>
            [ rooms先行 ]<br>{{ format(performance.ticketSales.roomsSale.start)  }}<br>~<br>{{ format(performance.ticketSales.roomsSale.end) }}</p></td>
        <td class="hide-on-mobile">{{ formatTime(performance.startDate) }}</td>

        <td class="hide-on-mobile" v-bind:class="{ 'highlight': isBetweenNow(performance.ticketSales.roomsSale?.start, performance.ticketSales.roomsSale?.end),
          'gray': isEnd(performance.ticketSales.roomsSale?.end),
          'white': isBeforeStart(performance.ticketSales.roomsSale?.start)}">
            {{ performance.ticketSales.roomsSale?.start ? format(performance.ticketSales.roomsSale.start) : "" }}<br/>
            <span>{{ performance.ticketSales.roomsSale?.start ? "〜" : "" }}</span><br/>
            {{ performance.ticketSales.roomsSale?.end ? format(performance.ticketSales.roomsSale.end) : "" }}
          </td>

          <td v-bind:class="{ 'highlight': isBetweenNow(performance.ticketSales.mobileSale?.start, performance.ticketSales.mobileSale?.end),
          'gray': isEnd(performance.ticketSales.mobileSale?.end),
          'white': isBeforeStart(performance.ticketSales.mobileSale?.start)}">
            {{ performance.ticketSales.mobileSale?.start ? format(performance.ticketSales.mobileSale.start) : "" }}<br/>
            <span>{{ performance.ticketSales.mobileSale?.start ? "〜" : "" }}</span><br/>
            {{ performance.ticketSales.mobileSale?.end ? format(performance.ticketSales.mobileSale.end) : "" }}
          </td>

          <td v-bind:class="{ 'highlight': isBetweenNow(performance.ticketSales.prioritySale?.start, performance.ticketSales.prioritySale?.end),
          'gray': isEnd(performance.ticketSales.prioritySale?.end),
          'white': isBeforeStart(performance.ticketSales.prioritySale?.start)}">
            {{ performance.ticketSales.prioritySale?.start ? format(performance.ticketSales.prioritySale.start) : "" }}<br/>
            <span>{{ performance.ticketSales.prioritySale?.start ? "〜" : "" }}</span><br/>
            {{ performance.ticketSales.prioritySale?.end ? format(performance.ticketSales.prioritySale.end) : "" }}
          </td>

          <td v-bind:class="{ 'highlight': isBetweenNow(performance.ticketSales.generalSale?.start, performance.ticketSales.generalSale?.end),
          'gray': isEnd(performance.ticketSales.generalSale?.end),
          'white': isBeforeStart(performance.ticketSales.generalSale?.start)}">
            {{ performance.ticketSales.generalSale?.start ? format(performance.ticketSales.generalSale.start) : ""}}<br/>
            <span>{{ performance.ticketSales.generalSale?.start ? "〜" : "" }}</span><br/>
            {{ performance.ticketSales.generalSale?.end ? format(performance.ticketSales.generalSale.end) : "" }}
          </td>
      </tr>
    </tbody>
    </table>

    <div class="affiliate-info-area affiliate-info-area-bottom" aria-label="NMB48関連アイテム">
      <a
        v-if="selectedRakutenNmbItem"
        class="nmb-item-affiliate-card affiliate-card"
        :href="selectedRakutenNmbItem.affiliateUrl"
        target="_blank"
        rel="nofollow sponsored noopener"
        @click="trackRakutenNmbItemClick(selectedRakutenNmbItem)"
      >
        <span class="nmb-item-affiliate-header">
          <span>NMB48関連アイテム</span>
          <span class="affiliate-card-pr">PR</span>
        </span>
        <span class="nmb-item-affiliate-body">
          <img
            class="nmb-item-affiliate-image"
            :src="selectedRakutenNmbItem.imageUrl"
            :alt="selectedRakutenNmbItem.name"
            loading="lazy"
            width="72"
            height="72"
          >
          <span class="nmb-item-affiliate-copy">
            <strong>{{ selectedRakutenNmbItem.name }}</strong>
            <span class="affiliate-card-cta">楽天で見る →</span>
          </span>
        </span>
      </a>
    </div>

    </div>

    <cast-modal :cast=selectedCastMember :name=selectedName :subname=selectedSubName :date="selectedDate" v-show="isShowModal" @close="closeModal"/>
    
  </div>
</template>

<script>
import CastModal from './CastModal.vue';
import { collection, getDocs } from "firebase/firestore";
import { logEvent } from "firebase/analytics";
import { db, analytics } from "../firebase";
import { RAKUTEN_NMB_ITEMS, RAKUTEN_TRAVEL_NAMBA_HOTELS_URL } from "../constants/affiliateLinks";
import dayjs from "dayjs";
import 'dayjs/locale/ja';
dayjs.locale("ja");

export default {
  name: "PerformancesList",
  data() {
    return {
      performances: [],
      selectedFilter: "all",
      isShowModal: false,
      selectedCastMember: "",
      selectedName: "",
      selectedDate: "",
      selectedSubName: "",
      lastUpdated: "---",
      rakutenTravelNambaHotelsUrl: RAKUTEN_TRAVEL_NAMBA_HOTELS_URL,
      selectedRakutenNmbItem: null,
    };
  },
  components: {
    CastModal,
  },
  computed: {
    filterPerformances(){
      if (this.selectedFilter === 'all'){
        return this.performances;
      }else if (this.selectedFilter === "available") {
        return this.performances.filter(performance => 
          this.isBetweenNow(performance.ticketSales.roomsSale?.start, performance.ticketSales.roomsSale?.end) ||
          this.isBetweenNow(performance.ticketSales.mobileSale?.start, performance.ticketSales.mobileSale?.end) ||
          this.isBetweenNow(performance.ticketSales.prioritySale?.start, performance.ticketSales.prioritySale?.end) ||
          this.isBetweenNow(performance.ticketSales.generalSale?.start, performance.ticketSales.generalSale?.end)
        );
      }else if (this.selectedFilter === "available-lottery") {
        return this.performances.filter(performance => 
          this.isBetweenNow(performance.ticketSales.roomsSale?.start, performance.ticketSales.roomsSale?.end) ||
          this.isBetweenNow(performance.ticketSales.mobileSale?.start, performance.ticketSales.mobileSale?.end) ||
          this.isBetweenNow(performance.ticketSales.prioritySale?.start, performance.ticketSales.prioritySale?.end)
        );
      }
      else{
        return this.performances;
      }
    }
  },
  async created() {
    const now = new Date();
    try {
      const querySnapshot = await getDocs(collection(db, "performances"));
      this.performances = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(doc => {
        const startDate = new Date(doc.startDate);
        return startDate >= now; 
      });


       // `updated`が存在する中で最新のタイムスタンプを取得
      const latestTimestamp = this.performances
        .filter(doc => doc.updated) // `updated`が存在するものだけを対象
        .map(doc => new Date(doc.updated.seconds * 1000)) // `updated`をDate形式に変換
        .reduce((latest, current) => (current > latest ? current : latest), new Date(0)); // 最新の時刻を取得

      this.lastUpdated = latestTimestamp > new Date(0)
        ? this.formatWithoutDayOfWeek(latestTimestamp) 
        : "---"; // 最新時刻がなければ空文字
    } catch (error) {
      console.error("Error fetching performances: ", error);
    }
  },
  mounted() {
    this.selectedRakutenNmbItem = this.pickRandomRakutenNmbItem();
  },
  methods : {
    format(date) {
      let formatted = dayjs(date).format('M/D (ddd) HH:mm');
      return formatted;
    },
    formatWithoutDayOfWeek(date) {
      let formatted = dayjs(date).format('M/D HH:mm');
      return formatted;
    },
    formatDay(date) {
      let formatted = dayjs(date).format('M/D (ddd)');
      return formatted;
    },
    formatTime(date) {
      let formatted = dayjs(date).format('HH:mm');
      return formatted;
    },
    isBetweenNow(start, end) {
      if (!start || !end) return false; // データがない場合はfalse
      const now = new Date();
      const startDate = new Date(start);
      const endDate = new Date(end);
      return startDate <= now && now <= endDate; // 現在時刻が範囲内にあるか
    },
    isBeforeStart(start){
      if (!start) return false; // データがない場合はfalse
      const now = new Date();
      const startDate = new Date(start);
      return now < startDate
    },
    isEnd(end) {
      if (!end) return true; // データがない場合はture
      const now = new Date();
      const endDate = new Date(end);
      return now > endDate;
    },
    hasCast(cast){
      return Array.isArray(cast) && cast.length > 0;
    },
    showModal(performance){
      this.selectedName = performance.name
      this.selectedSubName = performance.subname
      this.selectedDate = this.format(performance.startDate)
      this.selectedCastMember = performance.cast
      this.isShowModal = true
    },
    closeModal(){
      this.isShowModal = false
    },
    trackRakutenTravelClick(){
      logEvent(analytics, "affiliate_click", {
        affiliate: "rakuten_travel",
        destination: "namba_hotels",
        placement: "performance_list",
      });
    },
    pickRandomRakutenNmbItem(){
      const randomIndex = Math.floor(Math.random() * RAKUTEN_NMB_ITEMS.length);
      return RAKUTEN_NMB_ITEMS[randomIndex];
    },
    trackRakutenNmbItemClick(item){
      logEvent(analytics, "affiliate_click", {
        affiliate: "rakuten",
        category: "nmb_item",
        item: item.id,
        placement: "performance_list",
      });
    }
  },
};
</script>

<style scoped>

/* 全体の背景 */
.performance-table {
  margin: auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}

.content-area{
  margin: auto;
  width: 100%;
  max-width: 800px;
}

/* テーブルヘッダー */
.performance-table th {
  background-color: #e6ffe6; /* ペールグリーン */
  color: #333; /* ディープグレー */
  border: 1px solid #666; /* ペールパープル */
  padding: 8px 12px;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {

  .top {
    font-size: 12px; 
    margin-bottom: 8px;
  }

  .hide-on-mobile {
    display: none;
  }

  .mobile-only {
    display: inline;
  }

  .performance-table {
    font-size: 12px; 
  }

  .performance-table th {
    padding: 8px 8px;
  }

  .performance-table span {
    font-size: 11px; 
  }

  .performance-table button {
    font-size: 12px; 
    padding: 4px 8px;
  }

  p {
    font-size: 9pt;
    line-height: 1.1;
  }

}

@media (min-width: 769px) {
  .mobile-only {
    display: none;
  }
}

.performance-table .rooms-info{
  font-size: 8pt;
}

.performance-table .rooms-info-now{
  color:#000;
  font-weight: 600;
}

.performance-table .rooms-info-end{
  color:#aaa;
}

/* 通常セル */
.performance-table td {
  border: 1px solid #666; 
  padding: 6px 12px;
  color: #4a4a4a; /* ダークグレー */
}

/* 背景色 */
.performance-table tr {
  background-color: #f7c3a7;
}

.performance-table .yellow {
  background-color: #fffac0;
}

.performance-table .pink {
  background-color: #ffcee8; 
}

.performance-table .red {
  background-color: #ffc4c4; 
}

.performance-table .blue {
  background-color: #c7e5ff;
}

.performance-table .green {
  background-color: #caf7e4; 
}

.performance-table .purple {
  background-color: #e3c0ff; 
}

.performance-table .deepblue {
  background-color: #acbbff; 
}

/* 強調部分 */
.performance-table .highlight {
  color: #333; /* ディープグレー */
  font-weight: 600;
}

.performance-table .gray {
  background-color: #dcdcdc; /* ペールグレー */
  color: #aaa; /* ミディアムグレー */
}

.performance-table .white {
  background-color: #fff; 
  color: #333; /* ディープグレー */
}

/* 見出し */
h1 {
  font-size: 24px;
  margin-bottom: 16px;
  text-align: center;
  color: #4a4a4a; /* ダークグレー */
}

/* 段落 */
p {
  font-size: 10pt;
  line-height: 1.2;
  color: #666; /* ミディアムグレー */
  text-align: center;
}

.ad-disclosure {
  color: #555;
  font-weight: 600;
}

/* スパンの調整 */
tr span {
  font-size: small;
}

.filter-container {
  display: flex;
  justify-content: space-between; /* 左寄せと右寄せを実現 */
  align-items: center; /* 高さを揃える */
  margin-bottom: 4px;
}

#filter-select {
  margin-right: auto; /* 左寄せ */
  width: 200px;
  height: 28px;
}

.last-updated {
  margin-left: auto; /* 右寄せ */
  font-size: 12px; /* 小さな文字サイズ */
  color: #555; /* 少し目立たない色 */
}

.affiliate-info-area {
  display: grid;
  gap: 10px;
}

.affiliate-info-area-top {
  grid-template-columns: minmax(0, 1fr);
  margin: 0 auto 10px;
}

.affiliate-info-area-bottom {
  grid-template-columns: minmax(0, 420px);
  justify-content: center;
  margin: 12px auto 0;
}

.affiliate-card {
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px 14px;
  color: #4a4a4a;
  text-align: left;
  text-decoration: none;
  background: #fff;
  border: 1px solid #cdd9bd;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(74, 74, 74, 0.08);
}

.affiliate-card:hover,
.affiliate-card:focus {
  border-color: rgb(205, 219, 133);
  box-shadow: 0 2px 8px rgba(74, 74, 74, 0.14);
}

.travel-affiliate-icon {
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #333;
  font-size: 14px;
  font-weight: 700;
  background: #e6ffe6;
  border: 1px solid #cdd9bd;
  border-radius: 6px;
}

.travel-affiliate-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.affiliate-card-label {
  color: #666;
  font-size: 12px;
  line-height: 1.2;
}

.affiliate-card-pr {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 5px;
  color: #333;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  background: #e6ffe6;
  border: 1px solid #cdd9bd;
  border-radius: 4px;
}

.travel-affiliate-copy strong {
  color: #333;
  font-size: 15px;
  line-height: 1.3;
}

.affiliate-card-cta {
  color: #555;
  font-size: 13px;
  line-height: 1.3;
}

.nmb-item-affiliate-card {
  display: grid;
  gap: 8px;
}

.nmb-item-affiliate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #666;
  font-size: 12px;
  line-height: 1.2;
}

.nmb-item-affiliate-body {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.nmb-item-affiliate-image {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
}

.nmb-item-affiliate-copy {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.nmb-item-affiliate-copy strong {
  display: -webkit-box;
  overflow: hidden;
  color: #333;
  font-size: 13px;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

button {
  background-color: rgba(255, 255, 255, 0.8); 
  color: #333; /* ボタン文字色 */
  font-size: 14px; /* 文字サイズ */
  padding: 4px 16px; /* パディング */
  border: solid 2px rgb(205, 219, 133);
  border-radius: 5px; /* 角を丸める */
  margin-top: 4px;
}

@media (max-width: 768px) {
  .performance-table button {
    font-size: 12px;  /* フォントサイズを小さく */
    padding: 4px 8px; /* パディング */
  }

  .affiliate-info-area {
    gap: 8px;
  }

  .affiliate-info-area-top {
    margin-bottom: 8px;
  }

  .affiliate-info-area-bottom {
    grid-template-columns: 1fr;
    margin-top: 10px;
  }

  .affiliate-card {
    gap: 10px;
    padding: 10px;
  }

  .travel-affiliate-icon {
    flex-basis: 34px;
    width: 34px;
    height: 34px;
    font-size: 13px;
  }

  .travel-affiliate-copy strong {
    font-size: 14px;
  }

  .affiliate-card-cta {
    font-size: 12px;
  }

  .nmb-item-affiliate-body {
    gap: 9px;
  }

  .nmb-item-affiliate-image {
    flex-basis: 64px;
    width: 64px;
    height: 64px;
  }

  .nmb-item-affiliate-copy strong {
    font-size: 12px;
  }
}

</style>
